import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_CLINIC,
  DELETE_CLINIC,
  GET_CLINIC,
  GET_CLINIC_DETAILS,
  UPDATE_CLINIC,
} from "./actionTypes.js";

import {
  addClinicFail,
  addClinicSuccess,
  deleteClinicFail,
  deleteClinicSuccess, 
  getClinicDetailsFail,
  getClinicDetailsSuccess,
  getClinicFail,
  getClinicSuccess,
  updateClinicFail,
  updateClinicSuccess,
} from "./actions.js";

import {
  addNewClinic,
  clinicDetailsApi,
  clinicListingApi,
  delClinic,
  updateClinic,
} from "./clinicApi.js";

function* fetchClinic({ payload: length, sort, page,name, sort_by }) {
  try {
    const response = yield call(clinicListingApi, length, sort, page,name, sort_by)
    yield put(getClinicSuccess(response))
  } catch (error) {
    yield put(getClinicFail(error))
  }
}
function* fetchClinicDetails({ payload: id }) {
  try {
    const response = yield call(clinicDetailsApi, id)
    yield put(getClinicDetailsSuccess(response))
  } catch (error) {
    yield put(getClinicDetailsFail(error))
  }
}

function* onAddNewClinic({ payload: clinic }) {
  try {
    const response = yield call(addNewClinic, clinic)
    yield put(addClinicSuccess(response))
  } catch (error) {
    yield put(addClinicFail(error))
  }
}

function* onUpdateClinic({ payload: id, clinic }) {
  try {
    const response = yield call(updateClinic, id, clinic)
    yield put(updateClinicSuccess(response))
  } catch (error) {
    yield put(updateClinicFail(error))
  }
}

function* onDelClinic({ payload: id }) {
  try {
    const response = yield call(delClinic, id)
    yield put(deleteClinicSuccess(response))
  } catch (error) {
    yield put(deleteClinicFail(error))
  }
}


function* ClinicSaga() {
  yield takeEvery(GET_CLINIC, fetchClinic)
  yield takeEvery(GET_CLINIC_DETAILS, fetchClinicDetails)
  yield takeEvery(ADD_NEW_CLINIC, onAddNewClinic)
  yield takeEvery(UPDATE_CLINIC, onUpdateClinic)
  yield takeEvery(DELETE_CLINIC, onDelClinic)
}

export default ClinicSaga
